import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MppPageRoutingModule } from './mpp-routing.module';

import { MppPage } from './mpp.page';
import { SharedModule } from '@shared/shared.module';
import { MppShareModule } from './shared/mpp-shared.module';
import { EffectsModule } from '@ngrx/effects';
import { ClientMppEffects } from './effects/client-mpp.effects';
import { MppService } from './service/mpp.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MppPageRoutingModule,
    SharedModule,
    MppShareModule,
    EffectsModule.forFeature([ClientMppEffects]),
  ],
  declarations: [MppPage],
  providers: [MppService],
})
export class MppPageModule {}
